import type { SyncNetAdapter } from "@reciperoll/core";

// Connectivity via the browser. navigator.onLine is only reliably false when the
// browser is definitely offline (it can be optimistically true), which matches
// the engine's "only bail on a definite offline" contract.
export const webNet: SyncNetAdapter = {
  async isOnline() {
    return typeof navigator === "undefined" ? true : navigator.onLine;
  },
};
